import { useEffect, useState } from 'react';

/**
 * Mount non-critical UI after the browser is idle so its JS does not
 * compete with the first paint. `timeout` caps how long we wait.
 */
export default function useAfterIdle(timeout = 1800) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const done = () => {
      if (!cancelled) setReady(true);
    };

    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(done, { timeout });
      return () => {
        cancelled = true;
        window.cancelIdleCallback(id);
      };
    }

    const id = window.setTimeout(done, 1);
    return () => {
      cancelled = true;
      window.clearTimeout(id);
    };
  }, [timeout]);

  return ready;
}
